import { UserFREType } from "sh-models";
import { UserStore } from "sh-stores";

export function hasSeenFRE(freKey: UserFREType): boolean {
    // if we could not retrieve user settings, do not show fre
    // this is the case when GET api/account/settings call fails or not made yet
    if (!UserStore().userSettings) {
        return true;
    }
    const fresShownSoFar = UserStore().userSettings?.fresShownSoFar;
    // if fresShownSoFar is undefined instead of an empty array, do not show fre
    if (!fresShownSoFar) {
        return true;
    }
    // if fresShownSoFar is an empty array, user has not seen any fres yet
    if ( Array.isArray(fresShownSoFar) && fresShownSoFar.length === 0 ) {
        return false;
    }
    return fresShownSoFar.indexOf(freKey) !== -1;
}